var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card m-3 shadow"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-fill"},[_c('MeetingSearch')],1),_c('div',{staticClass:"float-end"},[_c('MeetingPagination')],1)])]),_c('div',{staticClass:"card-body"},[_c('MeetingTable')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }